var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgApedEmail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.018,
    height: 14.512,
    viewBox: "0 0 22.018 14.512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "aped-email",
    transform: "translate(-158.566 -76.6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M105.1,117.6a1.509,1.509,0,0,0-1.5,1.5v11.509a1.509,1.509,0,0,0,1.5,1.5h19.016a1.509,1.509,0,0,0,1.5-1.5V119.1a1.509,1.509,0,0,0-1.5-1.5Zm0,1h19.016a.489.489,0,0,1,.5.5v11.306l-6.247-6.247,6.359-4.856a.5.5,0,0,0-.6-.805l-9.517,7.233Zm-.5.876,6.247,4.683-6.247,6.247Zm7.053,5.286,2.658,1.994a.5.5,0,0,0,.594,0l2.658-1.994,6.349,6.349H105.306Z",
    transform: "translate(54.964 -41)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApedEmail);
export default __webpack_public_path__ + "static/media/aped-email.3ad9d4493dbda8c81bd49cc78d4656d7.svg";
export { ForwardRef as ReactComponent };